import moment from "moment";
import { defaultDebtLoadFormValues, defaultMonthlyIncomeAgreements } from "./constants/constants";

export const transformFormData = (data) => {
  const toBoolean = (value) => {
    if (value === "Да") return true;
    if (typeof value === 'boolean') return value;
    return false;
  };

  const formatDate = (date) => {
    if (!date) return null;
    return moment(date).utc().format();
  };
  const transformDebtValue = (isDebt, debtValue) => {
    return toBoolean(isDebt) ? parseFloat(debtValue) || 0.0 : 0.0;
  };

  const transformGuarantees = (guarantees) => {
    if (
      !guarantees ||
      !Array.isArray(guarantees)
    ) {
      return [];
    }

    return guarantees.map((guarantee) => ({
      ...guarantee,
      monthlyIncome: parseFloat(guarantee.monthlyIncome) || 0.0,
      incomeDocNumber: guarantee.incomeDocNumber || "",
      incomeDocDate: formatDate(guarantee.incomeDocDate),
    }));
  };

  const getEmploymentIndustry = () => {
    if (typeof data.employmentIndustry === 'object' && data.employmentIndustry !== null) {
      return data.employmentIndustry.label || '';
    }
    return data.employmentIndustry || '';
  };

  return {
    creditDebt: transformDebtValue(data.isCreditDebt, data.creditDebt),
    leasingDebt: transformDebtValue(data.isLeasingDebt, data.leasingDebt),
    microloanDebt: transformDebtValue(data.isMicroloanDebt, data.microloanDebt),
    goodsDebt: transformDebtValue(data.isGoodsDebt, data.goodsDebt),
    expireDebt: transformDebtValue(data.isExpireDebt, data.expireDebt),
    guaranteeAgreementDebt: transformDebtValue(data.isGuaranteeAgreements, data.guaranteeAgreementDebt),
    otherDebt: transformDebtValue(data.isOtherDebt, data.otherDebt),
    isEmployed: toBoolean(data.isEmployed),
    employmentIndustry: getEmploymentIndustry(),
    monthlyIncomeIndustry: parseFloat(data.employmentIndustry?.value) || parseFloat(data.monthlyIncomeIndustry) || 0.0,
    isIncomeConfirmed: Boolean(data.isIncomeConfirmed),
    monthlyIncome: parseFloat(data.monthlyIncome) || 0.0,
    monthIncomeDocs: transformGuarantees(data.monthIncomeDocs),
    isPensioner: toBoolean(data.isPensioner),
    isPensionConfirmed: Boolean(data.isPensionConfirmed),
    monthlyPension: parseFloat(data.monthlyPension) || 0.0,
    pensionIncomeDoc: {
      monthlyIncome: data.pensionIncomeDoc?.monthlyIncome || 0,
      incomeDocNumber: data.pensionIncomeDoc?.incomeDocNumber || "",
      incomeDocDate: formatDate(data.pensionIncomeDoc?.incomeDocDate),
    },
    currentDealAmount: parseFloat(data.currentDealAmount) || 0.0,
    currentDealDuration: data.currentDealDuration,
    clientId: data.clientId,
    previousDealId: data.previousDealId
  };
};

const formatIsDebt = (debt) => (debt > 0 ? "Да" : "Нет");

export const prepareFormData = (data) => {
  if (!data) return defaultDebtLoadFormValues;

  return {
    clientId: data.clientId,
    currentDealAmount: data.currentDealAmount,
    isCreditDebt: formatIsDebt(data.creditDebt),
    creditDebt: data.creditDebt,
    isLeasingDebt: formatIsDebt(data.leasingDebt),
    leasingDebt: data.leasingDebt,
    isMicroloanDebt: formatIsDebt(data.microloanDebt),
    microloanDebt: data.microloanDebt,
    isGoodsDebt: formatIsDebt(data.goodsDebt),
    goodsDebt: data.goodsDebt,
    isExpireDebt: formatIsDebt(data.expireDebt),
    expireDebt: data.expireDebt,
    isGuaranteeAgreements: formatIsDebt(data.guaranteeAgreementDebt),
    guaranteeAgreementDebt: data.guaranteeAgreementDebt,
    isOtherDebt: formatIsDebt(data.otherDebt),
    otherDebt: data.otherDebt,
    monthIncomeDocs: Boolean(data.monthIncomeDocs.length)
      ? data.monthIncomeDocs
      : [defaultMonthlyIncomeAgreements],
    isPensioner: data.isPensioner ? "Да" : "Нет",
    isEmployed: data.isEmployed ? "Да" : "Нет",
    isDebtExists: data.isDebtExists ? "Да" : "Нет",
    monthlyIncome: data.monthlyIncome,
    isIncomeConfirmed: data.isIncomeConfirmed,
    employmentIndustry: {
      label: data.employmentIndustry,
      value: data.monthlyIncomeIndustry || 0,
    },
    monthlyPension: data.monthlyPension,
    isPensionConfirmed: data.isPensionConfirmed,
    pensionIncomeDoc: data.pensionIncomeDoc,
  };
};
